<template>
  <div id="app" class="wrapper">
    <app-header v-if="this.isAuthenticated" />
    <app-sidebar v-if="this.isAuthenticated" />
    <app-content />
    <app-footer v-if="this.isAuthenticated" />
  </div>
</template>

<script>
import AppHeader from './pages/components/Header'
import AppSidebar from './pages/components/Sidebar'
import AppContent from './pages/components/Content'
import AppFooter from './pages/components/Footer'
import Menus from './../config/menus'

export default {
  name: 'App',
  data () {
    return {
      menus: Menus
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.state.auth.isAuthenticated
    }
  },
  replace: false,
  components: {
    'app-header': AppHeader,
    'app-sidebar': AppSidebar,
    'app-content': AppContent,
    'app-footer': AppFooter
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue